class ColourSwatches extends HTMLElement {
  constructor() {
    super();
    this.mainSwatch = this.querySelector('.main-swatch'); // main image container
    this.addEventListener('click', this.onSwatchClick.bind(this));
    this.addEventListener('variant-select-changed', this.onVariantSelectChanged.bind(this));
  }

  onSwatchClick(event) {
    const label = event.target.closest('.colour-swatch-option');
    if (!label || label.classList.contains('disabled')) return;

    const optionName = label.dataset.name;
    const optionValue = label.dataset.value;

    // Update checked state
    this.querySelectorAll('.colour-swatch-option').forEach(sw => sw.classList.remove('checked'));
    label.classList.add('checked');

    // Update main image if available
    this.updateMainImage(label.dataset.mainImageUrl);

    // Update the corresponding select/input in VariantSelects
    this.updateSelectOption(optionName, optionValue);
  }

  onVariantSelectChanged(event) {
    const { name, value } = event.detail;
    const matchingSwatch = this.querySelector(`.colour-swatch-option[data-name="${name}"][data-value="${value}"]`);
    if (!matchingSwatch) return;

    // Update checked state
    this.querySelectorAll('.colour-swatch-option').forEach(sw => sw.classList.remove('checked'));
    matchingSwatch.classList.add('checked');

    // Update main image
    this.updateMainImage(matchingSwatch.dataset.mainImageUrl);
  }

  updateMainImage(url) {
    if (!this.mainSwatch || !url) return;
    if (this.mainSwatch.tagName === 'IMG') {
      this.mainSwatch.src = url;
    } else {
      this.mainSwatch.style.backgroundImage = `url(${url})`;
    }
  }

  updateSelectOption(optionName, optionValue) {
    // Find the select with matching name in format options[Colour]
    const select = document.querySelector(`select[name="options[${optionName}]"]`);
    if (select) {
      select.value = optionValue;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // Also update radio inputs if they exist
    const input = document.querySelector(`input[type="radio"][name="${optionName}"][value="${optionValue}"]`);
    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

customElements.define('colour-swatches', ColourSwatches);

if (typeof VariantSelects !== 'undefined') {
  VariantSelects.prototype.updateColourSwatches = function () {
    const swatchesElements = document.querySelectorAll('colour-swatches');
    if (!swatchesElements.length) return;

    this.querySelectorAll('select').forEach((select) => {
      // Normalize name: options[Colour] → Colour
      const optionName = select.name.replace(/^options\[(.+)\]$/, '$1');
      const value = select.value;

      swatchesElements.forEach((swatches) => {
        // Only notify swatches that contain this option
        if (swatches.querySelector(`.colour-swatch-option[data-name="${optionName}"]`)) {
          swatches.dispatchEvent(
            new CustomEvent('variant-select-changed', {
              bubbles: true,
              detail: { name: optionName, value }
            })
          );
        }
      });
    });
  };

  // Delegated listener instead of wrapping onVariantChange directly.
  // Wrapping onVariantChange doesn't work here because VariantSelects binds
  // it in the constructor (this.addEventListener('change', this.onVariantChange.bind(this))),
  // which locks in the original function reference at element-upgrade time —
  // reassigning the prototype method afterwards has no effect on that binding.
  // Listening at the document level sidesteps this and also covers instances
  // added to the DOM after this script runs (e.g. quick-view, AJAX-loaded forms).
  document.addEventListener('change', (event) => {
    const variantSelects = event.target.closest('variant-selects');
    if (variantSelects && variantSelects.currentVariant) {
      variantSelects.updateColourSwatches();
    }
  });
}